export const isValidFrenchIban = (ibanRaw: string) => {
    const iban = String(ibanRaw ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

    if (!/^FR\d{2}\d{10}[A-Z0-9]{11}\d{2}$/.test(iban)) return false;

    const rearranged = iban.slice(4) + iban.slice(0, 4);

    let remainder = 0;
    for (const ch of rearranged) {
        const expanded = ch >= "A" && ch <= "Z" ? String(ch.charCodeAt(0) - 55) : ch;
        for (const digit of expanded) {
            remainder = (remainder * 10 + (digit.charCodeAt(0) - 48)) % 97;
        }
    }

    return remainder === 1;
};

export const isValidFrenchBic = (bicRaw: string) => {
    const bic = String(bicRaw ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

    return /^[A-Z]{4}FR[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bic);
};
